import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IUserRecordEmployeeService } from '@k12/admin-services';
import {
  EmployeeDataModel,
  EmployeeDetailService,
  EmployeeSchoolOption,
  EmployeeSubmitPayload,
  EmployeeSummary,
  EmployeeSummaryAdminPayload,
  State,
  SubService
} from '@k12/models';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const partnerEmployeeApiUrl = '/partners/employees';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService implements IUserRecordEmployeeService, EmployeeDetailService {
  private readonly http = inject(HttpClient);
  public selectedEmployeeIndex$ = new BehaviorSubject<number | undefined>(undefined);
  public myEmployees$ = new BehaviorSubject<EmployeeSummary[] | null>(null);

  CreateEmployee(payload: EmployeeSubmitPayload): Observable<EmployeeDataModel> {
    return this.http.post<EmployeeDataModel>(environment.adminApiUrl + partnerEmployeeApiUrl, payload);
  }

  UpdateEmployee(payload: EmployeeSubmitPayload): Observable<EmployeeDataModel> {
    return this.http.put<EmployeeDataModel>(
      environment.adminApiUrl + partnerEmployeeApiUrl + '/' + payload.id,
      payload
    );
  }

  GetAllEmployeesSummary(): Observable<EmployeeSummary[]> {
    return this.http.get<EmployeeSummary[]>(environment.adminApiUrl + partnerEmployeeApiUrl + '/summary');
  }

  GetProviderEmployeesSummary(providerId: string): Observable<EmployeeSummary[]> {
    return this.http.post<EmployeeSummary[]>(
      environment.adminApiUrl + '/partners/' + providerId + '/employees/summary',
      null
    );
  }

  GetAllEmployeesSummaryAdmin(
    programPartnerId: string,
    payload?: EmployeeSummaryAdminPayload
  ): Observable<EmployeeSummary[]> {
    return this.http.post<EmployeeSummary[]>(
      `${environment.adminApiUrl}/partners/${programPartnerId}/employees/summary`,
      payload
    );
  }

  GetEmployeeDetails(id: string): Observable<EmployeeDataModel> {
    return this.http.get<EmployeeDataModel>(environment.adminApiUrl + partnerEmployeeApiUrl + '/' + id);
  }

  DeleteEmployee(payload: { employeeId: string }): Observable<void> {
    return this.http.delete<void>(environment.adminApiUrl + partnerEmployeeApiUrl + '/' + payload.employeeId);
  }

  getSchools(): Observable<EmployeeSchoolOption[]> {
    return this.http.get<EmployeeSchoolOption[]>(environment.adminApiUrl + '/partners/schools');
  }

  getStates(): Observable<State[]> {
    return this.http.get<State[]>('/assets/data/states.json');
  }

  GetEmployeeSubServices(type: number): Observable<SubService[]> {
    return this.http.get<SubService[]>(
      environment.adminApiUrl + partnerEmployeeApiUrl + '/subservices?employeeType=' + type
    );
  }
}
